import {Form, Input} from 'antd';
import React from "react";
import {IFieldOptionsEditorProps} from "../FieldOptionsEditor";
import {CheckOutlined, CloseOutlined} from "@ant-design/icons";
import LocaleText from "../../../../settings/dictionary/LocaleText";

export interface IFieldIdOptions {
    identifierFormat?: string
}

interface IProps extends IFieldOptionsEditorProps {

}

interface IState {
}

class FieldIdOptionsEditor extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {}
    }

    render() {
        const {buildFieldName} = this.props
        return (
            <div>
                <Form.Item name={buildFieldName('identifierFormat')} initialValue={'#id'} label={<LocaleText code={'configuration.field.type.identifier.label'} fallback={'Formát'}/>} help={<LocaleText code={'configuration.field.type.identifier.help'} fallback={'Zachovejte #id, aby se id zobrazovalo v poli identifikátoru'}/> }>
                    <Input/>
                </Form.Item>
            </div>
        )
    }
}


export default FieldIdOptionsEditor